/* eslint-disable jsx-a11y/href-no-hash */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import { redirect } from 'widgets/I18nLink';
import { formatPrice, generatePreview } from 'utils';
import { CURRENCIES } from '../../../constants';

import './PopularSection.css';

class PopularSection extends PureComponent {
  static propTypes = {
    currency: PropTypes.string,
    bikeTypes: PropTypes.array,
    popularDestinations: PropTypes.array
  };

  onLinkClick(event, city) {
    event.preventDefault();

    const startOfHour = moment().startOf('hour');

    const query = {
      bikeTypes: city.bikeType,
      country: city.city.country,
      pickUpCity: city.city.id,
      dropOfCity: city.city.id,
      returnAtSameCity: true,
      begin: moment(startOfHour).add(2, 'days').toISOString(),
      end: moment(startOfHour).add(5, 'days').toISOString(),
      age: 21
    };

    redirect({
      pathname: '/search/',
      query
    });
  }

  render() {
    const { t, popularDestinations, bikeTypes } = this.props;

    const currency = CURRENCIES.find(c => c.value === this.props.currency);
    const symbol = currency && currency.symbol;

    return (
      <div className="section popular-section">
        <Grid>
          <h2>{t('Most popular destinations')}</h2>

          <Row componentClass="ul" className="home-popular-list">
            {(popularDestinations || []).map((city) => {
              const price = city.price.find(p => p.code === this.props.currency);
              const formattedPrice = formatPrice(price.price);
              const bikeType = bikeTypes && bikeTypes.find(bt => bt.id === city.bikeType);

              return (
                <Col componentClass="li" lg={3} md={4} sm={6} xs={12} key={city.city.name}>
                  <a href="#" className="popular-item" onClick={e => this.onLinkClick(e, city)}>
                    <div className="photo">
                      <img
                        alt=""
                        className="lazyload"
                        data-src={generatePreview(city.photo, 250, 215)}
                      />
                    </div>

                    <div>
                      {(bikeType) &&
                        <h3>{t(bikeType.name, { ns: 'bikeTypes' })} {t('from')} {formattedPrice}&nbsp;{symbol}</h3>
                      }
                    </div>

                    <span className="city">{t(city.city.nameEn, { ns: 'cities' })}</span>
                  </a>
                </Col>
              );
            })}
          </Row>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation', 'cities', 'bikeTypes'])(PopularSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/PopularSection/PopularSection.js